
import React from 'react';

import TextField from '../../../forms/TextField';

export default function Name(){
  return(
    <TextField
      name="name"
      label="Name"
      rules={{
        required: "Please enter a name."
      }}
      autoComplete="on"
    />
  )
}
